import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import { graphql } from 'src/generated';
import { CreateTableRowInput, type TableRow } from 'src/generated/graphql';
import { addTaskToBoardCache } from 'src/sections/@dashboard/board/shared/apolloCache.js';

//TODO: Move each function to a file
const createTableRowDoc = graphql(`
  mutation CreateTableRow($input: CreateTableRowInput!) {
    createTableRow(input: $input) {
      ...tableRow
    }
  }
`);

export const useTableRowCreateMutation = () => {
  const { user } = useAuthContext();

  const [mutate, { loading, error }] = useMutation(createTableRowDoc, {
    // @ts-ignore
    optimisticResponse: ({ input }) => ({
      createTableRow: {
        _id: `temp-id:${Date.now()}`,
        __typename: 'TableRow',
        rowId: 0,
        order: Infinity,
        tableId: input.tableId,
        columns: input.columns
          ? input.columns.map((c: any) => ({
              ...c,
              linkValue: c?.linkValue || null,
            }))
          : [],
        ownerId: user!._id,
        hasComments: false,
        unreadComments: 0,
        hasDescription: false,
        attachments: [],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        updatedBy: user!._id,
      },
    }),
    update(cache, { data }, { context, variables }) {
      if (!data || !variables) return;
      const { createTableRow } = data;
      if (!createTableRow) return;
      addTaskToBoardCache(cache, {
        boardId: (context as any)?.boardId,
        tableId: variables.input.tableId,
        rows: [createTableRow] as TableRow[],
      });
    },
  });

  const createTableRow = useCallback(
    async (boardId: string, input: CreateTableRowInput) =>
      mutate({
        variables: {
          input,
        },
        context: { boardId },
      }),
    [mutate],
  );

  return {
    createTableRow,
    isCreateTableRowLoading: loading,
    createTableRowError: error,
  };
};
